import React from "react";
import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8F9FA]"><PublicNav />
      <div className="max-w-lg mx-auto px-6 py-16">
        <Card className="p-8 text-center">
          <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold">Payment cancelled</h1>
          <p className="text-slate-600 mt-2">No amount was deducted. You can retry any time.</p>
          <Button className="mt-6" onClick={() => nav("/parent")} data-testid="pc-back">Back to Portal</Button>
        </Card>
      </div>
    </div>
  );
}
